
import { getUser } from '@/core/services/Apis'
import { COMMIT_UPDATE_USERNAME, COMMIT_SET_STATUS, COMMIT_UPDATE_USER } from '@/store/enums/mutations-types'


const module = {
  
  namespaced: true,
  state(){
    return{
      username: '',
      user: null
    }
  }, 
  getters: {
    firstName: (state) => (c) => {
      return state.username.split('').reverse().join(c)
    }
  }, mutations: {
    [COMMIT_UPDATE_USERNAME](state, payload){
      state.username = payload
    },
    [COMMIT_UPDATE_USER](state, payload){
      state.user = payload
    }
  },
  actions: {
    async updateUsername({commit, state, rootState}, payload){
      
      
      const user = await getUser(1)
      commit(COMMIT_UPDATE_USERNAME, user.username)
     if (user.username){
      commit(COMMIT_SET_STATUS, 'active', {root: true})
      console.log('status', rootState.status)
     }
      
    }
  },
}

export default module